module.exports = __webpack_public_path__ + "img/update3.5_image04.6d7dba6b.png";